<script>
  import { notEmpty, isValidEmail, checkPassword } from '../helpers/form-validation.js'
  import { push, link, querystring, replace } from 'svelte-spa-router'

  import { onMount } from 'svelte'
  import AuthContainer from './AuthContainer.svelte'
  import TextInput from '../components/TextInput.svelte'
  import Button from '../components/Button.svelte'
  import { snackBarStore, userStore } from '../state/store'
  const jwtDecode = require('jwt-decode')
  import { t } from '../i18n/i18n'

  let email = ''
  let password = ''
  let confirmPassword = ''

  onMount(() => {
    let params = new URLSearchParams($querystring)
    let urlEmail = params.get('email')
    email = urlEmail ? atob(urlEmail) : ''
  })

  $: passwordValid = checkPassword(password)
  $: emailValid = isValidEmail(email)
  $: formValid = passwordValid && emailValid && password === confirmPassword

  onMount(() => userStore.set({}))

  const submitForm = async () => {
    try {
      const response = await fetch('/api/user-meta', {
        method: 'PUT',
        body: JSON.stringify({
          email,
          password,
        })
      })

      if (!response.ok) throw new Error($t.incorrect_credentials)
      
      snackBarStore.set({ message: 'New password created.', type: 'success', selfDestruct: true })
      replace('/sign-in/')

    } catch (error) {
      snackBarStore.set({ message: $t.incorrect_credentials, type: 'error', selfDestruct: true })
    }
  }

</script>

<style>
  form {
    margin-bottom: 2rem;
  }

  p {
    font-size: 1.6rem;
    margin-top: 2.8rem;
  }
</style>
  
<AuthContainer>
  <h1>{$t['Create a new password']}</h1>
  <form on:submit|preventDefault={submitForm}>
    <div>
      <p>{$t['Login email']}</p>
      <p>{email}</p>
    </div>
    <TextInput
      id='password'
      label='{$t.password}'
      type='password'
      valid={passwordValid}
      toggleVisible=true
      validityMessage='{$t.valid_password_message}'
      staticMessage='{$t.password_rules}'
      value={password}
      on:input={event => (password = event.target.value)} />
    <TextInput
      id='confirmPassword'
      label='{$t['Confirm password']}'
      type='password'
      valid={password && password === confirmPassword}
      toggleVisible=true
      validityMessage='{$t.password_match}'
      value={confirmPassword}
      on:input={event => (confirmPassword = event.target.value)} />
    <Button type='submit' size='full' disabled={!formValid}>
      {$t.reset_password}
    </Button>
  </form>
  <p class='g-center'>
    <a href="/sign-in/" use:link>{$t['Back to Sign In']}</a>
  </p>
</AuthContainer>
